/**
 * Centralized preload configuration.
 * Single source of truth for critical images per route.
 * Keep in sync with content.json and index.html preload links.
 */

/** LCP / critical images for home page. Placeholder in index.html; hero GIF deferred (low priority in JS). Partnership CTA uses handshake-loop.webp — preload so it is cached before scroll. */
export const PRELOAD_HOME_CRITICAL = [
  '/hero/placeholder.png',
  '/ui/handshake-loop.webp',
];

/** Critical images for Services page (tier images + hero) */
export const PRELOAD_SERVICES_CRITICAL = [
  '/ui/office.png',
  '/services-images/services-hero.png',
  '/services-images/strategic-partnership.png',
];

/** Critical images for About page (first above-the-fold + section images) */
export const PRELOAD_ABOUT_CRITICAL = [
  '/about-images/global-network-legacy.png',
  '/about-images/strategic-partnerships.png',
  '/about-images/comprehensive-solutions.png',
  '/about-images/trust-integrity.png',
  '/about-images/dedicated-team.png',
];

/** Critical images for Contact page */
export const PRELOAD_CONTACT_CRITICAL = [];

/** Critical images for Disclaimer page */
export const PRELOAD_DISCLAIMER_CRITICAL = [];

/** Critical images for Privacy Policy page */
export const PRELOAD_PRIVACY_POLICY_CRITICAL = [];

/** Critical images for Terms & Conditions page */
export const PRELOAD_TERMS_CRITICAL = [];

/** Critical images for Legal Notice page */
export const PRELOAD_LEGAL_NOTICE_CRITICAL = [];

/** Critical images for Construction page */
export const PRELOAD_CONSTRUCTION_CRITICAL = [];

/** Critical images for Industrial Products page */
export const PRELOAD_INDUSTRIAL_PRODUCTS_CRITICAL = [];

/** Critical images for Electrical Products page */
export const PRELOAD_ELECTRICAL_PRODUCTS_CRITICAL = [];

/** Critical images for Chemical Products page */
export const PRELOAD_CHEMICAL_PRODUCTS_CRITICAL = [];

/** Critical images for Other Products page */
export const PRELOAD_OTHER_PRODUCTS_CRITICAL = [];

/** Solutions section/subsection pages: critical images are dynamic (from content per route). Use preloadCriticalImages() in page components. */
export const PRELOAD_SOLUTIONS_SECTION_CRITICAL = [];
export const PRELOAD_SOLUTIONS_SUBSECTION_CRITICAL = [];

/** Background preload: max subsections to preload per section (was 6) */
export const BACKGROUND_PRELOAD_MAX_SUBSECTIONS = 12;

/** Background preload: max sibling subsections on subsection page */
export const BACKGROUND_PRELOAD_MAX_SIBLINGS = 6;

/** Background preload concurrency */
export const BACKGROUND_PRELOAD_CONCURRENCY = 4;

/** Near-hover: distance in px from link to start preloading */
export const NEAR_HOVER_DISTANCE_PX = 120;

/** Transition durations (ms) for image fade-in */
export const TRANSITION_HERO_MS = 600;
export const TRANSITION_CARD_MS = 350;
